module.exports = __webpack_public_path__ + "static/media/map.e9b56b48.png";